import React from 'react';
import { IconStyled, IconStylesProps } from './IconStyles';

export const Success = ({ size = 'base', className = '' }: Partial<IconStylesProps>) => (
  <IconStyled
    size={size}
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0L24 0 24 24 0 24z" />
      <path
        fill="currentColor"
        d="M12 2c5.53 0 10 4.47 10 10s-4.47 10-10 10S2 17.53 2 12 6.47 2 12 2zm5.59 5L10 14.59l-3.59-3.58L5 12.42l5 5 9-9L17.59 7z"
      />
    </g>
  </IconStyled>
);
